"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_DEBUG = exports.IS_PROD = exports.IS_RELEASE = exports.IS_QA = exports.IS_CI = exports.IS_LOCAL = exports.ENV = exports.getVar = void 0;
var lodash_1 = __importDefault(require("lodash"));
var qs_1 = __importDefault(require("qs"));
function safeGetLocalStorage(key) {
    try {
        return localStorage.getItem(key);
    }
    catch (e) {
        console.error(e);
        return undefined;
    }
}
function getVar(key, type) {
    if (type === void 0) { type = 'string'; }
    // todo!!!
    var query = qs_1.default.parse(location.search, { ignoreQueryPrefix: true });
    if (lodash_1.default.has(query, key)) {
        var value = lodash_1.default.get(query, key);
        if (lodash_1.default.isNil(value)) {
            return true;
        }
        if (type === 'boolean') {
            if (lodash_1.default.lowerCase(value) === 'false') {
                return false;
            }
            else {
                return true;
            }
        }
        return value;
    }
    return safeGetLocalStorage(key);
}
exports.getVar = getVar;
exports.ENV = getVar('env');
exports.IS_LOCAL = (exports.ENV === 'local') || /local-/.test(location.host);
exports.IS_CI = (exports.ENV === 'ci') || /ci-/.test(location.host);
exports.IS_QA = (exports.ENV === 'qa') || /qa-/.test(location.host);
exports.IS_RELEASE = (exports.ENV === 'release') || /release-/.test(location.host);
exports.IS_PROD = !(exports.IS_QA || exports.IS_RELEASE);
exports.IS_DEBUG = getVar('fe_debug', 'boolean');
//# sourceMappingURL=environment.js.map